import tokenHttpClient from "../utils/httpClient";
import { getWithURLFileDownload } from "../utils/httpClient-methods";
import { BASE_URL, API_URL } from "../utils/AppApiUrl";

export const DownloadPortalGuideService = async (role) => {
  try {
    const param = {
      role,
    };
    const response = await getWithURLFileDownload(
      tokenHttpClient,
      `${BASE_URL}${API_URL.portalGuideDownload}`,
      param    
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
